export const NAMESPACE = 'mediapress-media';
export const STORE_NAME = 'bigbite/mediapress-media';
export const FILTER_NAMESPACE = 'mediaPress.media';
